<template>
  <div class="profile-quick-messages">
    <v-overlay :value="loading" z-index="4">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <ul class="profile-quick-messages__list">
      <li
        v-for="item in quickMessages"
        :key="item.id"
        class="profile-quick-messages__item"
      >
        <template v-if="!item.removed">
          <v-textarea
            v-model="item.message"
            label=""
            hide-details
            :outlined="item.isEditing"
            :readonly="!item.isEditing"
            placeholder="Type message here"
            rounded
            auto-grow
            class="profile-quick-messages__item-input"
            :class="item.isEditing ? 'bhWhite' : ''"
            no-resize
            rows="1"
            row-height="15"
            type="text"
          >
            <template v-slot:append>
              <v-icon
                class="profile-quick-messages__item-icon"
                v-if="!item.isEditing"
                v-on:click="removeQuickMessage(item)"
                color="accent"
              >
                bhi-trash
              </v-icon>
              <v-icon
                class="profile-quick-messages__item-icon"
                v-if="!item.isEditing"
                v-on:click="
                  setIsEditing(item);
                "
                color="accent"
              >
                bhi-pencil
              </v-icon>
              <v-icon
                class="profile-quick-messages__item-icon"
                v-if="item.isEditing"
                v-on:click="updateQuickMessage(item, item.message, item.oldMessage);"
                color="accent"
              >
                bhi-check-circle-filled
              </v-icon>
              <v-icon
                class="profile-quick-messages__item-icon"
                v-if="item.isEditing"
                v-on:click="cancelEditing(item);"
                color="accent"
              >
                bhi-close-circle
              </v-icon>
            </template>
          </v-textarea>
        </template>
      </li>
    </ul>
    <v-btn
      filled
      elevation="0"
      class="accent--text bhWhite profile-quick-messages__add-btn"
      v-on:click="addQuickMessage()"
    >
      <v-icon x-small>bhi-plus</v-icon> Add more
    </v-btn>
    <v-snackbar
      v-model="notificationSnackbar"
    >
      {{notificationSnackbarText}}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="notificationSnackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "ProfileQuickMessages",
  components: {},
  data: () => ({
    loading: false,
    notificationSnackbar: false,
    notificationSnackbarText: '',
    quickMessages: []
  }),
  computed: {
    ...mapGetters({
      getProfileId: "userStates/getProfileId"
    }),
  },
  methods: {
    ...mapActions('userStates',[
      'getProfileQuickMessages',
      'addProfileQuickMessages',
      'updateProfileQuickMessage',
      'deleteProfileQuickMessage'
    ]),
    forceEditQuickMessage(messageId, dataToChange) {
      let newQuickMessages = [
        ...this.quickMessages
      ];

      let quickMessageId = newQuickMessages.findIndex((el) => el.id == messageId);

      if (quickMessageId >= 0) {
        for(let i in dataToChange) {
          newQuickMessages[quickMessageId][i] = dataToChange[i];
        }
      }

      this.quickMessages = [
        ...newQuickMessages
      ];
    },
    cancelEditing(item) {
      if (String(item.id).indexOf('new-') === 0) {
        // Remove just from data, it's not in db
        this.quickMessages = [ ...this.quickMessages.filter(el => el.id !== item.id) ];

        return false;
      }

      this.forceEditQuickMessage(item.id, {
        message: item.oldMessage,
        isEditing: !item.isEditing
      });
    },
    setIsEditing(item) {
      this.forceEditQuickMessage(item.id, {
        oldMessage: item.message,
        isEditing: !item.isEditing
      });
    },
    getQuickMessages() {
      this.getProfileQuickMessages(
        {profileId: this.getProfileId}
      ).then(response=>{
        this.loading = false
        this.quickMessages = [ ...response.subobjects ] || []
      })          
    },
    removeQuickMessage(item) {
      const that = this;

      this.forceEditQuickMessage(item.id, {
        removed: true
      });

      this.deleteProfileQuickMessage({
        profileId: this.getProfileId,
        quickMessageId: item.id,
        headerVersion: item.version
      }).then(response => {
          that.quickMessages = [ ...that.quickMessages.filter(el => el.id !== item.id) ]
        }
      ).catch(error=>{
        that.forceEditQuickMessage(item.id, {
          removed: false
        })
      })
    },
    updateQuickMessage(item, message, oldMessage) {
      const that = this

      if (!message || message.length < 2) {
        that.notificationSnackbar = true
        that.notificationSnackbarText = "Quick message requires minimum 2 characters."

        return false;
      }

      this.forceEditQuickMessage(item.id, {
        isEditing: !item.isEditing
      })

      if (String(item.id).indexOf('new-') === 0) {
        // Add quick message
        this.submitNewQuickMessage(item.id, item.message, function(response) {
          if (response.error) {
            that.forceEditQuickMessage(item.id, {
              isEditing: true
            });
          }
        });

        return false;
      }

      this.updateProfileQuickMessage({
        profileId: this.getProfileId,
        quickMessageId: item.id,
        data: item.message,
        headerVersion: item.version
      }).then(response=> {
          this.forceEditQuickMessage(item.id, {
            oldMessage: item.message,
            version: response.version
          })
        })
      .catch(error=> {
        this.forceEditQuickMessage(item.id, {
          message: oldMessage
        })
      })
    },
    addQuickMessage() {
      this.quickMessages.push({
        id: `new-${this.quickMessages.length}`,
        message: "",
        oldMessage: "",
        isEditing: true
      });
    },
    submitNewQuickMessage(messageId, message, callback) {
      const that = this;

      // this.loading = true;
      this.addProfileQuickMessages(
        {profileId: this.getProfileId, data: message }
      ).then(response=> {
          const quickMessages = this.quickMessages.filter(el => el.id != messageId)
          this.quickMessages = [
            ...quickMessages,
            { ...response }
          ]
        }
      )
    }
  },
  mounted() {
    this.getQuickMessages();
    // console.log(this.getProfileId);
  }
};
</script>

<style lang="scss">
@import "@/styles/variables";

.profile-quick-messages {
  padding: 40px 40px 40px 34px;

  & &__list {
    margin: 0;
    padding: 0;
  }

  &__item {
    background-color: $bh-blue--4;
    list-style: none;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;

    &-input {
      padding: 0 24px;
      margin: 0;
      border-radius: 8px;


      &:not(.bhWhite) .v-input__slot {
        padding-left: 0;
        padding-right: 0;
      }

      fieldset {
        border-color: $bh-blue;
      }

      textarea {
        margin: 0 !important;
        padding-top: 12px;
        padding-bottom: 12px;
      }

      .v-input {

        &__slot {
          min-height: 48px !important;
        }

        &__append-inner {
          margin-top: 0;
          align-self: center;
        }
      }
    }

    &-icon {
      width: 16px;
      text-align: center;

      & + & {
        margin-left: 16px;
      }
    }
  }

  &__add-btn {
    .v-icon {
      margin-right: 10px;
    }
  }
}
</style>
